import { generateActions } from '../../utils'
import { API_CONST } from '../../middlewares/api'
import { handleActions, createAction } from 'redux-actions'

import { reformatLot } from '../../../selectors/lots'

const initial = {
  info: {},
  lots: [],
  active: null,
  init: false
}

const getActions = generateActions('persons/info/GET_INFO')
const getLotsActions = generateActions('persons/info/GET_LOTS')
const subscribeActions = generateActions('persons/info/SUBSCRIBE')
const getActiveLotActions = generateActions('persons/info/GET_ACTIVE_LOT')

export const get = createAction(
  API_CONST,
  personId => ({
    actions: getActions,
    url: `persons/${personId}`
  })
)

export const getLots = createAction(
  API_CONST,
  personId => ({
    actions: getLotsActions,
    url: `persons/${personId}/lots`
  })
)

export const getActiveLot = createAction(
  API_CONST,
  personId => ({
    actions: getActiveLotActions,
    url: `persons/${personId}/activeLot`
  })
)

export const subsribe = createAction(
  API_CONST,
  (personId, flag) => ({
    method: 'POST',
    actions: subscribeActions,
    params: { doSubscribe: flag },
    url: `persons/${personId}/changeSubscribe`
  }),
  (personId, flag) => ({ flag })
)

//reformat both lots and visits info
export function reformatLots(items) {
  var allLots = [];
  allLots = items.personLots.map(item => ({
    _id: item._id,
    name: item.fund.name,
    targetId: item.fund._id,
    sum: (item.bidsStats && item.bidsStats.bidSum) ? item.bidsStats.bidSum : 0,
    currency: (item.bidsStats && item.bidsStats.currencySymbol) ? item.bidsStats.currencySymbol : (item.currency && item.currency.symbol) ? item.currency.symbol : '₽',
    status: item.status,
    closeDate: item.closeDate,
    date: item.closeDate,
    startDate: item.startDate,
    winner: (item.user.firstname && item.user.lastname) ? `${item.user.firstname} ${item.user.lastname}` : (item.user.firstname ? item.user.firstname : "Нет победителя"),
    paidStatus: item.userStatus,
    fund: item.fund.name,
    isViewed: item.isViewed
  }))

  var visits = []
  visits = (items.personVisits.map(item => ({
    _id: item._id,
    name: item.fund.name,
    targetId: item.fund._id,
    date: item.closeDate,
    sum: (item.bidsStats && item.bidsStats.bidSum) ? item.bidsStats.bidSum : 0,
    currency: (item.bidsStats && item.bidsStats.currencySymbol) ? item.bidsStats.currencySymbol : (item.currency && item.currency.symbol) ? item.currency.symbol : '₽'
  })))

  var lots = []
  lots = (items.personAllLots.map(item => ({
    _id: item._id,
    name: item.fund.name,
    closeDate: item.closeDate,
    date: item.closeDate,
    startDate: item.startDate,
    status: item.status,
    fund: item.fund.name,
    paidStatus: item.userStatus,
    sum: (item.bidsStats && item.bidsStats.bidSum) ? item.bidsStats.bidSum : 0,
    currency: (item.bidsStats && item.bidsStats.currencySymbol) ? item.bidsStats.currencySymbol : (item.currency && item.currency.symbol) ? item.currency.symbol : '₽',
    alias: item.alias,
    isViewed: item.isViewed
  })))

  lots = lots.filter(lot => lot.status != "complete");

  var data = lots.concat(visits);
  data = data.concat(allLots);
  //var data = lots;
  return data
}

export default handleActions({
  [getActions[0]]: state => ({ ...initial }),
  [getActions[1]]: (state, { payload = {} }) => ({
    ...state,
    info: payload,
    init: true
  }),
  [getActions[2]]: state => ({
    ...initial,
    init: true
  }),
  [getLotsActions[0]]: state => ({
    ...state,
    lots: []
  }),
  [getLotsActions[1]]: (state, { payload = [] }) => ({
    ...state,
    lots: reformatLots(payload)
  }),
  [subscribeActions[1]]: (state, { meta }) => ({ ...state, info: { ...state.info, isSubscribed: meta.flag } }),
  [getActiveLotActions[0]]: state => ({ ...state, active: null }),
  [getActiveLotActions[1]]: (state, { payload = [] }) => ({
    ...state,
    active: payload.length
      ? reformatLot(payload[0])
      : null
  })
}, initial)



// WEBPACK FOOTER //
// ./src/store/reducers/persons/info.js